/**
 * ローダー
 */
let loading = () => {
  const overlay = document.getElementById('loading');
  if (!overlay) return;

  if (!overlay.classList.contains('g-loading-ine')) {
    window.addEventListener('load', () => {
      $(overlay).fadeOut(1000);
    }, false);
    return;
  }

  const markEl  = overlay.querySelector('.g-loading-ine__mark');
  const logo    = overlay.querySelector('.g-loading-ine__logo');

  // マークの全パス（stagger 対象）
  const markPaths = markEl ? [...markEl.querySelectorAll('path')] : [];

  // ロゴ内グループ（マーク・大テキスト・小テキスト）
  const logoSvg    = logo ? logo.querySelector('svg') : null;
  const logoGroups = logoSvg ? [...logoSvg.querySelectorAll('g, text')] : [];

  // 初期状態
  gsap.set(markPaths, { opacity: 0, y: 8 });
  gsap.set(markEl,    { opacity: 1 }); // コンテナは即表示（パスを hide して flash 防止）
  gsap.set(logo,      { opacity: 0, y: 16 });
  gsap.set(logoGroups, { opacity: 0 });

  let animDone = false;
  let pageDone = false;

  const dismiss = () => {
    if (!animDone || !pageDone) return;
    gsap.to(overlay, {
      yPercent: -100,
      duration: 0.85,
      ease: 'power2.inOut',
      delay: 0.4,
      onComplete: () => {
        overlay.style.display = 'none';
      }
    });
  };

  const tl = gsap.timeline({
    onComplete: () => {
      animDone = true;
      dismiss();
    }
  });

  // ① マークのパスを下から上へ stagger フェードイン
  tl.to(markPaths, {
    opacity: 1, y: 0,
    duration: 0.22,
    stagger: 0.055,
    ease: 'power2.out',
  })

  // ② ロゴコンテナをフェードアップ
  .to(logo, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '-=0.15')

  // ③ ロゴ内グループを順次フェードイン（マーク → 大テキスト → 小テキスト）
  .to(logoGroups, { opacity: 1, duration: 0.4, stagger: 0.16 }, '-=0.25');

  // ページロード完了を検知
  if (document.readyState === 'complete') {
    pageDone = true;
  } else {
    window.addEventListener('load', () => {
      pageDone = true;
      dismiss();
    }, false);
  }

  // フェイルセーフ：10秒で強制終了
  setTimeout(() => {
    animDone = true;
    pageDone = true;
    dismiss();
  }, 10000);
};

/**
 * 初期化
 */
let init = () => {
  loading();
};

export default { init, loading };
